import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Breadcrumbs,
  Link
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import PaymentIcon from '@mui/icons-material/Payment';
import SubscriptionPlans from '../../components/subscription/SubscriptionPlans';

const SubscriptionPage = () => {
  return (
    <Container maxWidth="lg">
      {/* Breadcrumb Navigation */}
      <Box sx={{ my: 3 }}>
        <Breadcrumbs 
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link
            underline="hover"
            sx={{ display: 'flex', alignItems: 'center' }}
            color="inherit"
            href="/dashboard"
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Dashboard
          </Link>
          <Typography
            sx={{ display: 'flex', alignItems: 'center' }}
            color="text.primary"
          >
            <PaymentIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Subscription Plans
          </Typography>
        </Breadcrumbs>
      </Box>
      
      {/* Page Header */}
      <Paper 
        elevation={0} 
        sx={{ 
          mb: 4, 
          p: 3, 
          borderRadius: 2,
          background: 'linear-gradient(135deg, #3f51b5 0%, #5c6bc0 100%)',
          color: 'white'
        }}
      >
        <Typography variant="h4" sx={{ mb: 1, fontWeight: 'medium' }}>
          Choose Your Subscription Plan
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.9, maxWidth: '800px' }}>
          Select the plan that best fits your needs. All plans include core platform features, with 
          higher tiers offering additional capabilities, storage, and support levels.
        </Typography>
      </Paper>
      
      {/* Subscription Plans Component */}
      <SubscriptionPlans />
      
      {/* Additional Info Section */}
      <Box sx={{ mt: 6, mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Frequently Asked Questions
        </Typography>
        
        <Paper sx={{ p: 3, borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom>
            How do subscriptions work?
          </Typography>
          <Typography variant="body2" paragraph>
            Our subscription plans are billed on a recurring basis. You'll be charged at the beginning
            of each billing cycle. You can upgrade, downgrade, or cancel your subscription at any time.
          </Typography>
          
          <Typography variant="h6" gutterBottom>
            Can I change plans later?
          </Typography>
          <Typography variant="body2" paragraph>
            Yes! You can upgrade or downgrade your plan at any time. When upgrading, you'll be charged
            the prorated difference for the remainder of your billing cycle. When downgrading, the change
            will take effect at the start of your next billing cycle.
          </Typography>
          
          <Typography variant="h6" gutterBottom>
            How do I cancel my subscription?
          </Typography>
          <Typography variant="body2" paragraph>
            You can cancel your subscription at any time from your account settings. When you cancel,
            you'll maintain access until the end of your current billing period.
          </Typography>
          
          <Typography variant="h6" gutterBottom>
            Do you offer refunds?
          </Typography>
          <Typography variant="body2" paragraph>
            We don't typically offer refunds for subscription payments. However, if you're experiencing issues 
            with the service, please contact our support team and we'll do our best to assist you.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default SubscriptionPage;